<div class="p-grid" style="margin: 15px;">
    <div class="p-col-12">

        <!-- FILTRE ENTETE -->
        <p-header>
          <!--   SECTION Volumetrie -->
          <div class="p-grid">
            <div class="p-col-12 p-lg-6 p-xl-6" >
              
            </div>
            <!--   SECTION DATE -->
            <div class="p-col-12 p-md-6 p-lg-4 p-xl-4">
              <button class="ui-fluid search" pButton [iconPos]="'right'" style="width: 100%; background-color: antiquewhite; border-color: antiquewhite; color:black; font-weight: bold;" icon="pi pi-calendar" label="Calendrier"  (click)="dateOverlay.toggle($event)"></button>
              <p-overlayPanel #dateOverlay [appendTo]="'body'">
                <p-tabView  [(activeIndex)]="activeIndexTabView">
                  <!-- <p-tabPanel header="Jour">
                    <p-calendar [(ngModel)]="valueDate" [inline]="true" dateFormat="yy-mm-dd" styleClass="yourClass"></p-calendar>
                  </p-tabPanel> -->
                  <!-- <p-tabPanel header="Semaine">
                    <p-calendar [(ngModel)]="valueSemaine" [inline]="true" selectionMode="range"
                                (onSelect)="selectRangeWeek($event)" dateFormat="yy-mm-dd" [yearNavigator]="true" [showWeek]="true" yearRange="2000:2030"></p-calendar>
                  </p-tabPanel> -->
                  <p-tabPanel header="Mois">
                    <p-calendar [(ngModel)]="valuMois" [inline]="true" view="month" dateFormat="yy-mm" [yearNavigator]="true" yearRange="2000:2030" [locale]="fr"></p-calendar>
                  </p-tabPanel>
                </p-tabView>
              </p-overlayPanel>
            </div>
            <!--   SECTION BOUTTON AFFICHER -->
            <div class="p-col-12 p-md-6 p-lg-2 p-xl-2">
              <p-button class="ui-fluid search" [iconPos]="'right'" style="width: 100%;" icon="pi pi-search" label="Afficher" (onClick)="loadFiltreReporting()"></p-button>
            </div>
            <div class="p-col-12" style="font-family: 'Open Sans', 'Helvetica Neue', sans-serif;text-align: center;">
                <h2>FACTURATION : {{mois}}</h2>
            </div>
          </div>
        </p-header>
    </div>

     


    <p-panel [header]="'GENERAL ('+ mois +')'"  class="performance p-col-12"></p-panel>

    <div class="p-col-12" style="overflow-x: auto;">
        <div class="p-grid" style="min-width: 1400px;"> 
            <div class="p-col-3" >  
                <p-panel  styleClass="card">
                    <p-header class="center-header">
                        Nombre total de fiches facturables
                    </p-header>
                    
                    <div class="center-number">
                            {{nbValides}}
                    </div>
                    
                </p-panel>
            </div>

            <div class="p-col-3" >  
                <p-panel  styleClass="card">
                    <p-header class="center-header">
                        Nombre total de fiches facturables / degré de complexité
                    </p-header>
                    <div style="display:flex;justify-content:center;align-items:center;">
                        <div>
                            <p-chart type="bar" [data]="validesParComplexite" [options]="nbTraiteesOptions" [height]="'310'"></p-chart>
                        </div>
                    </div>
                </p-panel>
            </div>

            <div class="p-col-3" >  
                <p-panel  styleClass="card">
                    <p-header class="center-header" class="center-header">
                        Nombre total de fiches en attente validation
                    </p-header>
                    <div class="center-number">
                        <div>
                            {{nbAttentes}}
                        </div>
                    </div>
                </p-panel>
            </div>

            <div class="p-col-3" >  
                <p-panel  styleClass="card">
                    <p-header class="center-header">
                        Nombre total de fiches en attente validation/ degré de complexité
                    </p-header>
                    <div style="display:flex;justify-content:center;align-items:center;">
                        <div>
                            <p-chart type="bar" [data]="attentesParComplexite" [options]="nbTraiteesOptions" [height]="'310'"></p-chart>
                        </div>
                    </div>
                </p-panel>
            </div>
        </div>
    </div>


    <p-panel class="p-col-12" styleClass="liste" header="LISTE DES FICHES EN ATTENTE DE VALIDATION DEPUIS PLUS DE DIX JOURS">
        <p-table #validees [selectionMode]="'single'" [scrollable]="true" [scrollHeight]="'200px'" styleClass="ui-table-customers" [columns]="listeAttenteCols" [value]="listeAttenteImportant">
            <ng-template pTemplate="caption" style="text-align:center;font-weight: bold;">
               <span></span>
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of listeAttenteCols" [pSortableColumn]="col.field">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" ></p-sortIcon>
                    </th>
                </tr>

            </ng-template>

            <ng-template pTemplate="body" let-moderation let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        <span>
                            {{moderation[col.field]}}
                        </span>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
                </tr>
            </ng-template>
        </p-table>
    </p-panel>


    <div class="p-col-12" style="margin: 17px auto;" >
        <div class="p-grid" *ngIf="!isClient()">
            <div class="p-col-12 p-lg-5 p-xl-3">
                <p-button class="ui-fluid" [iconPos]="'right'" style="width: 100%; background-color: antiquewhite; border-color: antiquewhite; color:black; font-weight: bold;" icon="pi pi-print" label="Effectuer une facturation" (click)="promptFacture()" [disabled]="btnFacturationDisable"></p-button>
            </div>
        </div>
    </div>

    <p-panel [header]="'VOLUMETRIE FICHES ('+ lastMois +')'"  class="performance p-col-12">
        <div class="overflow-container">
            <p-table #validees [rowHover]="true" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="volumetrieCols" [value]="lastMonthValues" >
                <ng-template pTemplate="caption" style="text-align:center;font-weight: bold;">
                </ng-template>
    
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of volumetrieCols" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" ></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
    
                <ng-template pTemplate="body" let-values let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
                          <span >
                            {{values[col.field]}}
                          </span>
                        </td>
                    </tr>
                </ng-template>
    
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-panel>

    <p-panel [header]="'VOLUMETRIE FICHES ('+ mois +')'"  class="performance p-col-12">
        <div class="overflow-container">
            <p-table #validees [rowHover]="true" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="volumetrieCols" [value]="currentMonthValues" >
                <ng-template pTemplate="caption" style="text-align:center;font-weight: bold;">
                </ng-template>
    
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of volumetrieCols" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" ></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
    
                <ng-template pTemplate="body" let-values let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
                          <span >
                            {{values[col.field]}}
                          </span>
                        </td>
                    </tr>
                </ng-template>
    
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-panel>

    <p-panel header="VOLUMETRIE FICHES (DEPUIS LE DEBUT)"  class="performance p-col-12">
        <div class="overflow-container">
            <p-table #validees [rowHover]="true" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="volumetrieCols" [value]="allMonthValues" >
                <ng-template pTemplate="caption" style="text-align:center;font-weight: bold;">
                </ng-template>
    
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of volumetrieCols" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" ></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
    
                <ng-template pTemplate="body" let-values let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
                          <span >
                            {{values[col.field]}}
                          </span>
                        </td>
                    </tr>
                </ng-template>
    
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-panel>

    <!-- <p-panel header="DETAILS"  class="performance p-col-12" [toggler]="'header'" [toggleable]="true" [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'" [collapsed]="true"> -->
        <!-- TABLEAU VALIDEES-->
       <!--  <div *ngIf="selectedOptionVolumetrie === 0" class="p-col-12">
            <p-table #validees [rowHover]="true" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="tableauCols" [value]="listeValidees" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Fiche {first} à {last} sur un total de {totalRecords} fiches">
              <ng-template pTemplate="caption" style="text-align:center;font-weight: bold;">
                 <span>Cumul fiches validées / degré de complexité</span>
              </ng-template>

              <ng-template pTemplate="header">
                  <tr>
                      <th *ngFor="let col of tableauCols" [pSortableColumn]="col.field">
                          {{col.header}}
                          <p-sortIcon [field]="col.field" ></p-sortIcon>
                      </th>
                  </tr>

                  <tr>
                      <th *ngFor="let col of tableauCols" [ngSwitch]="col.field">

                        <p-multiSelect [appendTo]="'body'" *ngSwitchCase="'id_complexite'" [style]="{'width':'100%', 'min-height':'30px'}" [options]="complexteFilter" defaultLabel="Toutes" (onChange)="validees.filter($event.value, col.field, 'in')"></p-multiSelect>
                    
                      </th>
                  </tr>

              </ng-template>

              <ng-template pTemplate="body" let-moderation let-columns="columns">
                  <tr>
                      <td *ngFor="let col of columns">
                        <ng-template [ngIf]="col.field === 'id_complexite'">
                          <span>
                              {{ getComplexite(moderation[col.field]) }}
                          </span>
                      </ng-template>

                      <ng-template [ngIf]="col.field !== 'id_complexite'">
                        <span >
                          {{moderation[col.field]}}
                        </span>
                      </ng-template>
                      </td>
                  </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                  <tr>
                      <td colspan="3" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
                  </tr>
              </ng-template>
          </p-table>
        </div> -->
        <!-- FIN TABLEAU VALIDEES -->


        <!-- TABLEAU EN ATTENTE-->
        <!-- <div *ngIf="selectedOptionVolumetrie === 1" class="p-col-12">
            <p-table #validees [rowHover]="true" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="tableauCols" [value]="listeAttente" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Fiche {first} à {last} sur un total de {totalRecords} fiches">
              <ng-template pTemplate="caption">
                Cumul fiches en attente validation / degré de complexité
              </ng-template>

              <ng-template pTemplate="header">
                  <tr>
                      <th *ngFor="let col of tableauCols" [pSortableColumn]="col.field">
                          {{col.header}}
                          <p-sortIcon [field]="col.field" ></p-sortIcon>
                      </th>
                  </tr>

                  <tr>
                      <th *ngFor="let col of tableauCols" [ngSwitch]="col.field">

                        <p-multiSelect [appendTo]="'body'" *ngSwitchCase="'id_complexite'" [style]="{'width':'100%', 'min-height':'30px'}" [options]="complexteFilter" defaultLabel="Toutes" (onChange)="validees.filter($event.value, col.field, 'in')"></p-multiSelect>
                    
                      </th>
                  </tr>

              </ng-template>

              <ng-template pTemplate="body" let-moderation let-columns="columns">
                  <tr>
                      <td *ngFor="let col of columns">
                        <ng-template [ngIf]="col.field === 'id_complexite'">
                          <span>
                              {{ getComplexite(moderation[col.field]) }}
                          </span>
                      </ng-template>

                      <ng-template [ngIf]="col.field !== 'id_complexite'">
                        <span >
                          {{moderation[col.field]}}
                        </span>
                      </ng-template>
                      </td>
                  </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                  <tr>
                      <td colspan="3" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
                  </tr>
              </ng-template>
          </p-table>
        </div> -->
        <!-- FIN TABLEAU EN ATTENTE -->
    <!-- </p-panel> -->
</div>